
(function(){
const root=document.getElementById("oneone-origami-configurator");if(!root||!window.ONEONE_CONFIG_DATA)return;
const D=window.ONEONE_CONFIG_DATA,T=D.text,O=D.order;
function el(t,c,h){const n=document.createElement(t);if(c)n.className=c;if(h!==undefined)n.innerHTML=h;return n}
function opt(s,a,p){s.innerHTML="";const o=document.createElement("option");o.value="";o.textContent=p;s.appendChild(o);a.forEach(v=>{const x=document.createElement("option");x.value=v;x.textContent=v;s.appendChild(x)})}
function ix(x){return O.indexOf(x)}
function vkey(b,m,y){return b+"|||"+m+"|||"+y}
function vinfo(b,m,y){return D.vehicleLookup[vkey(b,m,y)]||null}
function profile(breed){return (D.simpleBreedProfiles||[]).find(x=>x.breed===breed)||null}
function breeds(){return (D.simpleBreedProfiles||[]).map(x=>x.breed).sort()}
function fitsVehicle(vehicle,box){
 if(!vehicle||!vehicle.origamiVehiclePossible) return null;
 const possible=vehicle.origamiVehiclePossible||[];
 if(possible.includes("XL")){ if(box==="S"||box==="M"||box==="XL") return true; if(box==="L") return possible.includes("L"); }
 if(possible.includes("L")){ if(box==="S"||box==="M"||box==="L") return true; if(box==="XL") return possible.includes("XL"); }
 if(possible.includes("M")){ if(box==="S"||box==="M") return true; }
 if(possible.includes("S")){ if(box==="S") return true; }
 return possible.includes(box);
}
function pickRecommendation(vehicle,p){
 if(!p && (!vehicle||!vehicle.origamiVehiclePrimary)) return {main:null,alt:null,status:"manual",msg:T.manualMsg};
 if(!p) return {main:vehicle.origamiVehiclePrimary,alt:null,status:"vehicleOnly",msg:T.vehicleOnly};
 if(!vehicle||!vehicle.origamiVehiclePrimary) return {main:p.recommended,alt:p.alternative,status:"vehicleManual",msg:T.vehicleManual};
 let main=p.recommended, alt=p.alternative;
 if(!fitsVehicle(vehicle,main)){
   if(alt && fitsVehicle(vehicle,alt)) return {main:alt,alt:null,status:"adjusted",msg:T.adjusted};
   const fallback=O.filter(b=>fitsVehicle(vehicle,b)).sort((a,b)=>ix(b)-ix(a))[0]||null;
   if(!fallback) return {main:null,alt:null,status:"manual",msg:T.noSafe};
   return {main:fallback,alt:null,status:"manualFit",msg:T.manualFit};
 }
 if(alt && !fitsVehicle(vehicle,alt)) alt=null;
 return {main,alt,status:"ok",msg:T.ok};
}
function boxCard(boxId,title,text,cls){
 const b=D.boxes[boxId];
 return `<div class="${cls}"><div class="oneone-kicker">${title}</div><h3>${b.name}</h3><p class="oneone-sub">${text||""}</p><div class="oneone-specs"><div class="oneone-spec"><strong>${T.mass}</strong><br>${b.w} × ${b.h} × ${b.d} cm</div><div class="oneone-spec"><strong>${T.crash}</strong><br>${b.testedKg} kg</div></div></div>`;
}
root.innerHTML="";
const wrap=el("div","oneone-wrap");
wrap.innerHTML=`<div class="oneone-pill">${T.pill}</div><h2 class="oneone-title">${T.title}</h2><p class="oneone-lead">${T.lead}</p>`;
const grid=el("div","oneone-grid"),form=el("div","oneone-card"),res=el("div","oneone-card oneone-result");
const fields=el("div","oneone-fields");
function field(label){const w=el("div","oneone-field"),l=el("label",null,label),s=document.createElement("select");w.append(l,s);return{w,s}}
const breed=field(T.breed),brand=field(T.brand),model=field(T.model),year=field(T.year);
fields.append(breed.w,brand.w,model.w,year.w);
const btn=el("button","oneone-btn",T.btn);
form.append(fields,btn,el("div","oneone-info",T.dataInfo));
res.innerHTML=`<div class="oneone-empty"><div><div class="oneone-kicker">${T.result}</div><h3>${T.emptyTitle}</h3><p>${T.emptyText}</p></div></div>`;
grid.append(form,res);wrap.appendChild(grid);root.appendChild(wrap);
opt(breed.s,breeds(),T.breed);
opt(brand.s,D.brands,T.brand);
opt(model.s,[],T.model);
opt(year.s,[],T.year);
brand.s.addEventListener("change",()=>{opt(model.s,D.modelsByBrand[brand.s.value]||[],T.model);opt(year.s,[],T.year)});
model.s.addEventListener("change",()=>{opt(year.s,((D.yearsByBrandModel[brand.s.value]||{})[model.s.value])||[],T.year)});
btn.addEventListener("click",()=>{
 const b=brand.s.value,m=model.s.value,y=year.s.value,br=breed.s.value;
 if(!b||!m||!y){res.innerHTML=`<div class="oneone-empty"><div><h3>${T.carIncomplete}</h3><p>${T.carIncompleteText}</p></div></div>`;return}
 const vi=vinfo(b,m,y),p=profile(br),rec=pickRecommendation(vi,p);
 if(!rec.main){
   res.innerHTML=`<div class="oneone-badge">${T.manual}</div><h3>${T.manualTitle}</h3><p class="oneone-sub">${b} ${m}, ${y}${br?" · "+br:""}</p><div class="oneone-error">${rec.msg}</div><div class="oneone-cta-row"><a class="oneone-secondary" href="mailto:info@1one1-goods.com?subject=Origami%20Configurator%20Check">${T.advice}</a></div>`;
   return;
 }
 const mainText=p?p.text:T.basedVehicle;
 let html=`<div class="oneone-badge">${T.recommended}</div><p class="oneone-sub">${b} ${m}, ${y}${br?" · "+br:""}</p>`;
 if(rec.status!=="ok") html+=`<div class="oneone-warning">${rec.msg}</div>`;
 html+=boxCard(rec.main,T.recommended,mainText,"oneone-mainrec");
 if(rec.alt){
   const altBox=D.boxes[rec.alt];
   html+=`<div class="oneone-alt"><div class="oneone-kicker">${T.alternative}</div><h3>${altBox.name}</h3><p class="oneone-sub">${T.altText}</p></div>`;
 }
 html+=`<p class="oneone-small">The final fit should always be verified in the vehicle and according to the individual dog's size and body shape. In some vehicles, the crate may need to be elevated slightly to allow the door to open fully, for example due to loading lips or vehicle-specific design features.</p>`;
 res.innerHTML=html;
});
})();